export function RegionFlag({
  region = "ie",
  size = 20,
  className,
}: {
  region?: "ie" | "uk";
  size?: number;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      style={{ width: size, height: size }}
      className={`inline-block shrink-0 overflow-hidden rounded-full ${className ?? ""}`}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={`/assets/region/${region}.svg`}
        alt={region === "uk" ? "United Kingdom flag" : "Ireland flag"}
        width={size}
        height={size}
        className="h-full w-full object-cover"
      />
    </span>
  );
}
